import { createFileRoute } from '@tanstack/react-router'

import { CustomerPageWrapper } from '@/components/molecules/customer-page-wrapper'
import PageHeader from '@/components/molecules/shared/page-header'
import { AccountingQuestions } from '@/features/accounting/pages/questions'
import Head from '@/lib/navigation/head'

function QuestionsRoute() {
  return (
    <>
      <Head>
        <title>Questions | Nonresident Tax</title>
      </Head>
      <CustomerPageWrapper stickyHeader={<PageHeader title="Questions" sticky />}>
        <AccountingQuestions />
      </CustomerPageWrapper>
    </>
  )
}

export const Route = createFileRoute('/_shell/accounting/questions')({
  component: QuestionsRoute,
})
